export default "__VITE_ASSET__Xt37a4hZ__"